import { useEtsyCircuitBreakerStore } from '@/helpers/etsy-circuit-breaker';
export default {
  path: '/shop-info',
  name: 'shop-info',
  component: () => import('@/modules/shop-info/pages/ShopInfo.vue'),
  meta: {
    metaTags: [
      {
        name: 'description',
        content: 'View important statistics about any Etsy shop, see where it ranks, and gain insight into its success.',
      },
      {
        name: "google",
        content: "notranslate",
      },
      {
        page_slug: 'shop-info',
      },
    ],
    title: 'eRank — Shop Info',
    requiresAuth: true,
  },
  children: [
    {
      path: ':shopName',
      children: [
        {
          path: '',
          name: 'shop-overview',
          component: () => import('@/modules/shop-info/pages/Overview.vue'),
          meta: {
            requiresAuth: false,
            scrollGroup: 'shop-info',
          },
        },
        {
          path: 'listings',
          name: 'shop-listings',
          component: () => import('@/modules/shop-info/pages/Listings.vue'),
          meta: {
            requiresAuth: true,
            scrollGroup: 'shop-info',
          },
        },
        {
          path: 'tags',
          name: 'shop-tags',
          component: () => import('@/modules/shop-info/pages/TopTags.vue'),
          meta: {
            requiresAuth: true,
            scrollGroup: 'shop-info',
          },
        },
        {
          path: 'tags/:tag',
          name: 'shop-tag-occurrences',
          component: () => import('@/modules/shop-info/pages/TagOccurrences.vue'),
          meta: {
            requiresAuth: true,
            activeTab: 'shop-tags',
            scrollGroup: 'shop-info',
          },
        },
      ],
    },
  ],
  beforeEnter: async () => {
    const etsyCircuitBreakerStore = useEtsyCircuitBreakerStore();
    const response = await etsyCircuitBreakerStore.requestStatus();
    etsyCircuitBreakerStore.setActions(response.data);
    return true;
  },
};
